import React, { useEffect, useState, useRef } from "react";
import LoadingBar from "react-top-loading-bar";
import { Link, navigate } from "gatsby";
import "./../include/css/bootstrap.min.css";
import "./../include/css/product-gridview.css";
import "./../include/css/style.css";
import "./../include/css/banner.css";
import "./../include/css/dev.css";

import algoliasearch from "algoliasearch";
import _ from "lodash";
import queryString from "query-string";

//  Components
import FilterSidebar from "../components/filterSidebar";
import FilterModal from "../components/filtersModal";
import Footer from "../components/common/footer";
import FilterSideBarMobile from "../components/filterSidebarMobile";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
// import SEO from "./../components/seo";
import { isMobile } from "react-device-detect";
import Help from "../components/help";
import { SEO } from "../components/seo";
import { imageUrl, numberFormat } from "../actions/miscAction";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import ShareWithMyBuyers from "../components/shareWithBuyersModal";
import { getCount } from "../actions/memberAction";
import { getAviationPartsCount } from "../actions/dashboardAction";
import Header from "../components/newDesign/header/header";

const emptyIcon = imageUrl("list.svg");
const darkClose = imageUrl("darkClose.svg");
const aviationImg = imageUrl("Rectangle+3472.png");

const client = algoliasearch(process.env.GATSBY_ALGOLIA_APP_ID, process.env.GATSBY_ALGOLIA_API_KEY);
const index = client.initIndex(process.env.GATSBY_ALGOLIA_LISTINGS_INDEX);
const App = (props) => {
  const { pageContext: data } = props;
  const path = props?.location?.pathname || "";
  const { allManufacturers, allRegions, allCategories, allUpcomingBidDropDown } = props.pageContext;
  const ref = useRef(null);
  const [filters, setFilters] = useState({ ready: false, filters: [] });
  const [hideLvlOne, setHideLvlOne] = useState(false);
  const [crumbs, setCrumbs] = useState([]);
  const [canonical, setCanonical] = useState(null);
  const [prevPage, setPrevPage] = useState(null);
  const [nextPage, setNextPage] = useState(null);
  const [signupCard, setSignUpCard] = useState(true);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filterModalData, setFilterModalData] = useState([]);
  const [filterModalDataCounts, setFilterModalDataCounts] = useState([]);
  const [modalType, setModalType] = useState("");
  const [facets, setFacets] = useState({});
  const [catagory, setCatagory] = useState([]);
  const [catagory1, setCategory1] = useState([]);
  const [catagory2, setCategory2] = useState([]);
  const [aviationModel, setAviationModel] = useState([]);
  const [make, setMake] = useState([]);
  const [model, setModel] = useState([]);
  const [region, setRegion] = useState([]);
  const [region1, setRegion1] = useState([]);
  const [conditionType, setConditionType] = useState([]);
  const [pageTittle, setPageTittle] = useState([
    "Global Marketplace for Asset Recovery and Surplus Inventory | Salvex",
  ]);
  const [gridView, setGridView] = useState(isMobile ? false : true);
  const [listings, setListings] = useState([]);
  const [queryData, setQueryData] = useState("");
  const [numberOfRecord, setNumberOfRecord] = useState(0);
  const [page, setPage] = useState(0);
  const [maxPage, setMaxPage] = useState(0);
  const [loadingMain, setLoadingMain] = useState(true);
  const [loadingBook, setLoadingBook] = useState(false);
  const [archiveFor, setArchive] = useState(false);
  const [filterChange, setFilterChange] = useState("");
  const [showFilterSidebarMobile, setShowFilterSideBarMobile] = useState(false);
  const [cleared, setCleared] = useState(false);
  const [showMobileFilter, setShowMobileFilter] = useState(false);
  const [showHelp, setShowHelp] = useState(false);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [oldFacets, setOldFacets] = useState(null);
  const [listingView, setListingView] = useState(true);
  const [showBuyerModal, setShowBuyerModal] = useState(false);
  const [selectedListing, setSelectedListing] = useState(null);
  const [dashboardCount, setDashboardCount] = useState(null);
  const [wantedListing, setWantedListing] = useState(data.wanted ? true : false);
  const [count, setCount] = useState(0);
  const [wantedCount, setWantedcount] = useState(0);
  const [pushCategory, setPushCategory] = useState("");

  const toggleBuyerModal = () => {
    setShowBuyerModal(!showBuyerModal);
  };

  const toggleHelpModal = () => {
    setShowHelpModal(!showHelpModal);
  };

  const toggleMobileFilter = (e) => {
    if (e) e.preventDefault();
    setShowMobileFilter(!showMobileFilter);
  };

  const clearFilter = async (type, location = false) => {
    setFilterChange("");
    if (type === "catagory" || type === "all") {
      await setCatagory([]);
    }
    if (type === "catagory1" || type === "all") {
      await setCategory1([]);
    }
    if (type === "catagory2" || type === "all") {
      await setCategory2([]);
    }
    if (type === "aviationModel" || type === "all") {
      await setAviationModel([]);
    }
    if (type === "conditionType" || type === "all") {
      await setConditionType([]);
    }
    if (type === "make" || type === "all") {
      await setMake([]);
    }
    if (type === "model" || type === "all") {
      await setModel([]);
    }
    if (type === "region" || type === "all") {
      await setRegion([]);
    }
    if (type === "region1" || type === "all") {
      await setRegion1([]);
    }
    if (type === "category" || type === "all") {
      if (!location) setQueryData("");
    }
    setShowFilterModal(false);
    setCleared(true);
    prepareFilters();
  };

  const setQueryParameters = (uri, params) => {
    Object.keys(params).forEach((key) => {
      const value = params[key];
      const re = new RegExp("([?&])(" + key + "=)[^&#]*", "g");
      if (uri.match(re)) {
        uri = uri.replace(re, `$1$2${value}`);
      } else {
        const paramString = (uri.indexOf("?") < 0 ? "?" : "&") + key + "=" + value;
        const hashIndex = uri.indexOf("#");
        uri = hashIndex < 0 ? uri + paramString : uri.substring(0, hashIndex) + paramString + uri.substring(hashIndex);
      }
    });
    return uri;
  };
  const handleChange = (event, value) => {
    if (value - 1 <= maxPage) {
      setPage(value - 1);

      const urlLocation = typeof window !== "undefined" && window?.location?.pathname + window?.location?.search;

      // Add multiple parameters
      const updatedParams = {
        page: value,
        listing: wantedListing ? "wanted" : "sale",
      };

      const updatedUrl = setQueryParameters(urlLocation, updatedParams);

      navigate(updatedUrl);
    }
  };

  const setData = async (key, val) => {
    setFilterChange(key);
    handleChange("e", 1);
    if (key === "catagory") {
      const checkCat = catagory.find((v) => v === val);
      if (checkCat) {
        const newCat = catagory.filter((v) => v !== val);
        await setCatagory(newCat);
      } else {
        const updateCat = [...catagory];
        updateCat.push(val);
        setPushCategory(val);
        await setCatagory(updateCat);
      }
    }

    if (key === "catagory1") {
      const checkCat1 = catagory1.find((v) => v === val);
      if (checkCat1) {
        const newCat1 = catagory1.filter((v) => v !== val);
        await setCategory1(newCat1);
      } else if (data?.category?.category_id == 1176 || data?.mainCategory?.category_id == 1176) {
        const updateCat1 = [];
        updateCat1.push(val);
        await setCategory1(updateCat1);
      } else {
        const updateCat1 = [...catagory1];
        updateCat1.push(val);
        setPushCategory(val);
        await setCategory1(updateCat1);
      }
    }

    if (key === "catagory2") {
      const checkCat2 = catagory2.find((v) => v === val);
      if (checkCat2) {
        const newCat2 = catagory2.filter((v) => v !== val);
        await setCategory2(newCat2);
      } else {
        const updateCat2 = [...catagory2];
        updateCat2.push(val);
        setPushCategory(val);
        await setCategory2(updateCat2);
      }
    }
    if (key === "aviationModel") {
      const checkCat2 = aviationModel.find((v) => v === val);
      if (checkCat2) {
        const newCat2 = aviationModel.filter((v) => v !== val);
        await setAviationModel(newCat2);
      } else {
        const updateCat2 = [...aviationModel];
        updateCat2.push(val);
        await setAviationModel(updateCat2);
      }
    }
    if (key === "conditionType") {
      const checkConditionType = conditionType.find((v) => v === val);
      if (checkConditionType) {
        const newConditionType = conditionType.filter((v) => v !== val);
        await setConditionType(newConditionType);
      } else {
        const checkConditionType = [...conditionType];
        checkConditionType.push(val);
        await setConditionType(checkConditionType);
      }
    }

    if (key === "make") {
      const checkMake = make.find((v) => v === val);
      if (checkMake) {
        const newMake = make.filter((v) => v !== val);
        await setMake(newMake);
      } else {
        const updateMake = [...make];
        updateMake.push(val);
        await setMake(updateMake);
      }
    }

    if (key === "model") {
      const checkModel = model.find((v) => v === val);
      if (checkModel) {
        const newModel = model.filter((v) => v !== val);
        await setModel(newModel);
      } else {
        const updateModel = [...model];
        updateModel.push(val);
        await setModel(updateModel);
      }
    }

    if (key === "region") {
      const checkRegion = region.find((v) => v === val);
      if (checkRegion) {
        const newRegion = region.filter((v) => v !== val);
        await setRegion(newRegion);
      } else {
        const updateRegion = [...region];
        updateRegion.push(val);
        await setRegion(updateRegion);
      }
    }
    if (key === "region1") {
      const checkRegion1 = region1.find((v) => v === val);
      if (checkRegion1) {
        const newRegion1 = region1.filter((v) => v !== val);
        await setRegion1(newRegion1);
      } else {
        const updateRegion1 = [...region1];
        updateRegion1.push(val);
        await setRegion1(updateRegion1);
      }
    }
    prepareFilters();
  };

  const loadData = async (query = "") => {
    ref && ref.current && ref.current.continuousStart();
    try {
      if (!filters.ready) return console.log("loadData  filters not ready");
      let facets = [
        "categories.lvl0",
        "categories.lvl1",
        "categories.lvl2",
        "aviation_model_name",
        "conditionType",
        "make",
        "model",
        "regions.lvl0",
        "regions.lvl1",
        "at_id",
        "push_categories",
      ];
      // if (hideLvlOne) {
      //   facets = ["categories.lvl1", "make", "model", "region", "regions.lvl1"];
      // }
      const records = await index.search(queryData || queryString.parse(props.location.search).q, {
        facetFilters: filters.filters,
        facets: facets,
        hitsPerPage: 50,
        page: page,
      });

      if (filters?.filters?.includes("at_id:6")) {
        let newFilters = filters.filters;
        const index1 = newFilters?.indexOf("at_id:6");

        if (index1 !== -1) {
          newFilters[index1] = "at_id:-6";
        }
        const records2 = await index.search(queryData || queryString.parse(props.location.search).q, {
          facetFilters: newFilters,
          facets: ["at_id"],
        });
        setCount(records2.nbHits);
      } else {
        let newFilters = filters.filters;
        const index1 = newFilters?.indexOf("at_id:-6");

        if (index1 !== -1) {
          newFilters[index1] = "at_id:6";
        }
        const records1 = await index.search(queryData || queryString.parse(props.location.search).q, {
          facetFilters: newFilters,
          facets: ["at_id"],
        });
        setWantedcount(records1.nbHits);
      }

      const listingsData = records.hits?.sort((a, b) => {
        return (b?.category == data?.category?.description) - (a?.category == data?.category?.description);
      });
      setNumberOfRecord(records.nbHits);
      setMaxPage(records.nbPages);

      canonicalPages(records.nbPages);
      setListings(listingsData);

      if (filterChange) {
        if (filterChange == "make") {
          const facetRecords = { ...records?.facets };
          facetRecords.make = oldFacets.make;
          setFacets(facetRecords);
          setOldFacets(facetRecords);
        } else if (filterChange == "model") {
          const facetRecords = { ...records?.facets };
          facetRecords.model = oldFacets.model;
          setFacets(facetRecords);
          setOldFacets(facetRecords);
        } else if (filterChange == "region") {
          const facetRecords = { ...records?.facets };

          facetRecords.region = oldFacets.region;
          setFacets(facetRecords);
          setOldFacets(facetRecords);
        } else if (filterChange == "region1") {
          const facetRecords = { ...records?.facets };

          facetRecords["regions.lvl1"] = oldFacets["regions.lvl1"];
          setFacets(facetRecords);
          setOldFacets(facetRecords);
        } else if (filterChange == "catagory") {
          setFacets(records.facets);
          setOldFacets(records.facets);
        } else if (filterChange == "catagory1") {
          const facetRecords = { ...records?.facets };
          facetRecords["categories.lvl1"] = oldFacets["categories.lvl1"];
          setFacets(facetRecords);
          setOldFacets(facetRecords);
        } else if (filterChange == "catagory2") {
          const facetRecords = { ...records?.facets };
          facetRecords["categories.lvl2"] = oldFacets["categories.lvl2"];
          setFacets(facetRecords);
          setOldFacets(facetRecords);
        } else if (filterChange == "aviationModel") {
          const facetRecords = { ...records?.facets };
          facetRecords["aviation_model_name"] = oldFacets["aviation_model_name"];
          setFacets(facetRecords);
          setOldFacets(facetRecords);
        } else if (filterChange == "conditionType") {
          const facetRecords = { ...records?.facets };
          facetRecords["conditionType"] = oldFacets["conditionType"];
          setFacets(facetRecords);
          setOldFacets(facetRecords);
        }
      } else {
        setOldFacets(records.facets);
        setFacets(records.facets);
      }

      if (Object.keys(facets).length === 0) setFacets(records.facets);
      setLoadingMain(false);
    } catch (e) {
      if (e.status === 400) {
        navigate("/404");
      } else if (e.status === 500) {
        navigate("/500");
      }
    }
    ref.current && ref.current.complete();
  };

  const loadFilter = async () => {
    try {
      const filters = [];

      const records = await index.search("", {
        facetFilters: filters,

        facets: ["categories.lvl0", "categories.lvl1", "make", "model", "regions.lvl0", "regions.lvl1"],
        hitsPerPage: 50,
        page: page,
      });
      setFacets(records.facets);
    } catch (e) {
      if (e.status === 400) {
        navigate("/404");
      } else if (e.status === 500) {
        navigate("/500");
      }
    }
  };

  useEffect(() => {
    const Qdata = queryString.parse(props.location.search);
    if (Qdata.page) {
      setWantedListing((Qdata.listing === "sale" || !Qdata?.listing) && !data.wanted ? false : true);
      setPage(parseInt(Qdata.page) - 1);
    } else {
      setWantedListing((Qdata.listing === "sale" || !Qdata?.listing) && !data.wanted ? false : true);

      setPage(0);
    }
    if (Qdata.q) setQueryData(Qdata.q);
  }, [props.location.search]);

  useEffect(() => {
    setLoadingMain(true);

    if (!filters.ready) {
      prepareFilters();
    }
    loadData();
  }, [filters.ready, props.location.search, queryData, queryString.parse(props.location.search).q]);

  useEffect(() => {
    prepareFilters();
  }, [wantedListing]);

  useEffect(() => {
    if (filters.ready) {
      prepareFilters();
    }
  }, [props.location.search]);

  const prepareFilters = async () => {
    const arr = [];

    setFilters({ ready: false, filters: [] });

    if (!filters.ready) {
      const Qdata = queryString.parse(props.location.search);

      let category = null;
      let mfrDescription = null;
      let regionDescription = null;
      let canonicalParams = [];

      if (data.category && data.category.category_id) {
        const mainC = data.category;
        const mainCategory = data.mainCategory;

        if (mainC) {
          let crumbs = [];
          mainC.description !== "All Listings" && setArchive(mainC.category_id);
          if (mainC.level > 0) {
            setHideLvlOne(true);
            const catArray = [];
            catArray.push(
              `categories.lvl${mainC.level - 1}:${
                mainCategory
                  ? `${mainCategory.description}_${
                      mainCategory?.description == "Textiles" ? 1012 : mainCategory.category_id
                    } > ${mainC.description}_${mainC.category_id}`?.replace("&", "and")
                  : `${mainC.description}_${mainC.category_id}`?.replace("&", "and")
              }`,
            );
            catArray.push(
              `push_categories:${
                mainCategory
                  ? `${mainCategory.description}_${
                      mainCategory?.description == "Textiles" ? 1012 : mainCategory.category_id
                    } > ${mainC.description}_${mainC.category_id}`?.replace("&", "and")
                  : `${mainC.description}_${mainC.category_id}`?.replace("&", "and")
              }`,
            );
            arr.push(catArray);
          }
          category = mainC.description;

          if (mainC.fullpath) {
            crumbs.unshift({
              link: data.mainCategory ? null : "/listings/index.cfm/catid/" + mainC.category_id,
              text: mainC.description.replace("&amp;", ""),
            });
          }
          if (data.mainCategory) {
            crumbs.unshift({
              link: "/listings/index.cfm/catid/" + data.mainCategory.category_id,
              text: data.mainCategory.description.replace("&amp;", ""),
            });
          }
          setCrumbs(crumbs);
        }
      }
      if (Qdata["enddate"]) {
        arr.push(`end_date:${Qdata["enddate"]}`);
      }

      Object.keys(queryString.parse(props.location.search)).forEach((element) => {
        let pageTitle = queryString.parse(props.location.search)[element];
        setPageTittle(
          wantedListing
            ? `Used ${category ? category : ""} For Procurement in Online Surplus Auctions`
            : `Used ${pageTitle} For Sale in Online Surplus Auctions | Salvex`,
        );

        if (element === "mfr") {
          arr.push(`make:${queryString.parse(props.location.search)[element]}`);
        }
        if (element === "model") {
          arr.push(`model:${queryString.parse(props.location.search)[element]}`);
        }

        if (element === "region") {
          arr.push(`regions.lvl0:${queryString.parse(props.location.search)[element]}`);
        }
        if (element === "regions.lvl1") {
          arr.push(
            `regions.lvl1:${
              queryString.parse(props.location.search)[element] == "Vietnam"
                ? "Viet Nam"
                : queryString.parse(props.location.search)[element]
            }`,
          );
        }

        if (element === "category") {
          arr.push(`categories.lvl0:${queryString.parse(props.location.search)[element]}`);
        }
      });

      if (data.manufacturer) {
        const mainMfr = data.manufacturer;
        canonicalParams.push("mfr=" + mainMfr.mfrid.toString());
        mfrDescription = mainMfr.description;
        arr.push(`make:${mfrDescription}`);
      }

      if (data.geoRegion) {
        if (data.geoRegion.geoRegionID === 111) {
          const mainRegion = data.geoRegion;
          canonicalParams.push(
            data.geoRegion.region_id
              ? "geoRegionID=" + data.geoRegion.region_id.toString()
              : "geoRegionID=" + data.geoRegion.geoRegionID.toString(),
          );
          regionDescription = mainRegion.geoRegion || mainRegion.description;

          arr.push(["regions.lvl0:Carribean", "regions.lvl0:South America", "regions.lvl0:Central America"]);
        } else {
          const mainRegion = data.geoRegion;
          canonicalParams.push(
            data.geoRegion.region_id
              ? "geoRegionID=" + data.geoRegion.region_id.toString()
              : "geoRegionID=" + data.geoRegion.geoRegionID.toString(),
          );
          regionDescription =
            mainRegion.geoRegion === "Americas" ? "South America" : mainRegion.geoRegion || mainRegion.description;

          if (data.parentrEGION && data.parentrEGION.geoRegion === "North America") {
            arr.push("regions.lvl1:United States > " + mainRegion.description);
          } else {
            if (mainRegion.description == "Vietnam") {
              arr.push(data.geoRegion.region_id ? "regions.lvl1:Viet Nam" : "regions.lvl0:" + regionDescription);
            } else {
              arr.push(
                data.geoRegion.region_id
                  ? "regions.lvl1:" + mainRegion.description
                  : "regions.lvl0:" + regionDescription,
              );
            }
          }
        }
      }

      if (data?.conditionType) {
        arr.push(`conditionType:${data?.conditionType[0]}`);
      }

      if (wantedListing) {
        arr.push(`at_id:6`);
      } else {
        arr.push(`at_id:-6`);
      }

      setCanonical(
        (process.env.GATSBY_APP_MODE === "prod"
          ? "https://www.salvex.com/listings/index.cfm/?"
          : "http://localhost:8000/listings/index.cfm/?") + canonicalParams.join("&"),
      );
      const catArray = [];
      const catagory1Array = [];
      const catagory2Array = [];
      const aviationArray = [];
      const conditionArray = [];
      const makeArray = [];
      const modelArray = [];
      const regionArray = [];
      const region1Array = [];

      catagory.map((ec) => catArray.push(`categories.lvl0:${ec}`));
      catagory.map((ec) => catArray.push(`push_categories:${ec}`));

      catagory1.map((ec) => catagory1Array.push(`categories.lvl1:${ec}`));
      catagory1.map((ec) => catagory1Array.push(`push_categories:${ec}`));

      catagory2.map((ec) => catagory2Array.push(`categories.lvl2:${ec}`));
      catagory2.map((ec) => catagory2Array.push(`push_categories:${ec}`));

      aviationModel.map((ec) => aviationArray.push(`aviation_model_name:${ec}`));
      conditionType.map((ec) => conditionArray.push(`conditionType:${ec}`));
      make.map((ec) => makeArray.push(`make:${ec}`));
      model.map((ec) => modelArray.push(`model:${ec}`));
      region.map((ec) => regionArray.push(`regions.lvl0:${ec}`));
      region1.map((ec) => region1Array.push(`regions.lvl1:${ec == "Vietnam" ? "Viet Nam" : ec}`));

      arr.push(catArray);
      arr.push(catagory1Array);
      arr.push(catagory2Array);
      arr.push(aviationArray);
      arr.push(conditionArray);
      arr.push(makeArray);
      arr.push(modelArray);
      arr.push(regionArray);
      arr.push(region1Array);

      setPageTittle(
        wantedListing
          ? `Used ${category ? category : ""} For Procurement in Online Surplus Auctions`
          : `Used ${category ? category : ""} For Sale in Online Surplus Auctions ${
              regionDescription ? " in " + regionDescription : ""
            }${mfrDescription ? " made by " + mfrDescription : ""}`,
      );

      if (
        (category && category.description == "Aviation") ||
        (crumbs && crumbs.length > 0 && crumbs[0].text && crumbs[0].text == "Aviation")
      ) {
        setShowHelp(true);
      } else if (category && category.description != "Aviation") {
        setShowHelp(false);
      }
      setFilters({ ready: true, filters: arr });
    }
  };

  useEffect(() => {
    if (data?.category?.category_id !== 1001) {
      const mainC = data.category;
      const mainCategory = data.mainCategory;

      if (mainCategory) {
        const updateCat = [...catagory];
        updateCat.push(
          `${mainCategory.description}_${mainCategory?.description == "Textiles" ? 1012 : mainCategory.category_id}`,
        );
        setCatagory(updateCat);
      }

      if (mainC) {
        if (data?.category?.category_id == 1176 || data?.mainCategory?.category_id == 1176) {
          const updateCat1 = [];
          updateCat1.push(
            mainCategory
              ? `${mainCategory?.description}_${
                  mainCategory?.description == "Textiles" ? 1012 : mainCategory?.category_id
                } > ${mainC?.description}_${mainC?.category_id}`
              : `${mainC?.description}_${mainC?.category_id}`,
          );
          if (mainCategory?.description) {
            setCategory1(updateCat1);
          }
        } else {
          const updateCat1 = [...catagory1];
          updateCat1.push(
            mainCategory
              ? `${mainCategory?.description}_${
                  mainCategory?.description == "Textiles" ? 1012 : mainCategory?.category_id
                } > ${mainC?.description}_${mainC?.category_id}`
              : ` ${mainC?.description}_${mainC?.category_id}`,
          );
          if (mainCategory?.description) {
            setCategory1(updateCat1);
          }
        }
      }
    }
  }, [data.category?.category_id]);

  const canonicalPages = (maxPage) => {
    if (page > 0) setPrevPage(page);
    else setPrevPage(null);
    if (page + 2 <= maxPage) setNextPage(page + 2);
    else setNextPage(null);
  };

  useEffect(() => {
    if (!loadingMain) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [page]);

  const totalPages = numberOfRecord ? Math.ceil(numberOfRecord / 50) : 1;

  let pages = _.range(
    page - 5 < 0 ? 0 : page - 5,
    Math.ceil(numberOfRecord / 50) > 10 ? page + 5 : Math.ceil(numberOfRecord / 50),
  );

  let mobilePages = _.range(
    page - 3 < 0 ? 0 : page - 2,
    Math.ceil(numberOfRecord / 50) > 2 ? page + 2 : Math.ceil(numberOfRecord / 50),
  );

  const removeFilter = async (index, type) => {
    setFilterChange("");
    if (type === "catagory") {
      const data = [...catagory];
      data.splice(index, 1);
      await setCatagory(data);
    } else if (type === "catagory1") {
      const data = [...catagory1];
      data.splice(index, 1);
      await setCategory1(data);
    } else if (type === "catagory2") {
      const data = [...catagory2];
      data.splice(index, 1);
      await setCategory2(data);
    } else if (type === "aviationModel") {
      const data = [...aviationModel];
      data.splice(index, 1);
      await setAviationModel(data);
    } else if (type === "conditionType") {
      const data = [...conditionType];
      data.splice(index, 1);
      await setConditionType(data);
    } else if (type === "make") {
      const data = [...make];
      data.splice(index, 1);
      await setMake(data);
    } else if (type === "model") {
      const data = [...model];
      data.splice(index, 1);
      await setModel(data);
    } else if (type === "region") {
      const data = [...region];
      data.splice(index, 1);
      await setRegion(data);
    } else if (type === "region1") {
      const data = [...region1];
      data.splice(index, 1);
      await setRegion1(data);
    }
    prepareFilters();
  };
  var filterCount = 0;
  if (catagory.length > 0) {
    filterCount = filterCount + catagory.length;
  }
  if (catagory1.length > 0) {
    filterCount = filterCount + catagory1.length;
  }
  if (catagory2.length > 0) {
    filterCount = filterCount + catagory2.length;
  }
  if (aviationModel.length > 0) {
    filterCount = filterCount + aviationModel.length;
  }
  if (conditionType.length > 0) {
    filterCount = filterCount + conditionType.length;
  }
  if (make.length > 0) {
    filterCount = filterCount + make.length;
  }
  if (model.length > 0) {
    filterCount = filterCount + model.length;
  }
  if (region.length > 0) {
    filterCount = filterCount + region.length;
  }
  if (region1.length > 0) {
    filterCount = filterCount + region1.length;
  }

  const callbackBookmark = (res) => {
    setTimeout(() => setLoadingBook(false), 1500);
    //loadData()
  };

  // useEffect(() => {
  //   if (typeof window !== "undefined") {
  //     navigate(null, {
  //       state: {
  //         page,
  //         totalPages,
  //       },
  //     });
  //   }
  // }, [page, totalPages]);

  const isLoggedIn = typeof window !== "undefined" && localStorage.getItem("token");
  const loggedInUser =
    typeof window !== "undefined" && localStorage.getItem("token") ? JSON.parse(localStorage.getItem("member")) : "";
  const mimicMember = typeof window !== "undefined" && JSON.parse(localStorage.getItem("mimicmember"));

  useEffect(() => {
    getAviationPartsCount((res) => {
      if (res?.status === 200) {
        setDashboardCount(res?.data);
      }
    });
  }, []);

  return (
    <>
      <LoadingBar color="#47ad1d" ref={ref} />

      <Header />
      {!loadingMain && showHelp && <Help show={showHelpModal} onHide={toggleHelpModal} />}
      <>
        <div className="header-bottom d-flex align-items-center d-lg-none">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="breadcrumb-container d-none d-md-block">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/listings/index.cfm/catid/1001">All Listings</Link>
                    </li>
                    {crumbs.map((crumb) => (
                      <li class="breadcrumb-item">
                        {crumb.link ? <a href={`${crumb.link}`}>{crumb.text}</a> : <span>{crumb.text}</span>}
                      </li>
                    ))}
                  </ol>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <div className="filter-result-box">
                    {pageTittle}
                    <span>( {numberOfRecord} )</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="filter-outer-container">
          <div className="filter-container w-lg-100 d-lg-flex flex-lg-wrap">
            <FilterSidebar
              facets={facets}
              setData={setData}
              catagory={catagory}
              catagory1={catagory1}
              catagory2={catagory2}
              aviationModel={aviationModel}
              make={make}
              model={model}
              region={region}
              region1={region1}
              conditionType={conditionType}
              toggleFilter={() => setShowFilterModal(!showFilterModal)}
              filterModalData={(data) => setFilterModalData(data)}
              filterModalDataCounts={(count) => setFilterModalDataCounts(count)}
              modalType={(t) => setModalType(t)}
              clearFilter={(val) => clearFilter(val)}
              removeFilter={removeFilter}
              setGridView={setGridView}
              loadingMain={loadingMain}
              mainCategory={data}
              path={path}
            />
            <div className="fc-main-content-box fc-main-content-box-new">
              {!loadingMain &&
              ((catagory?.length == 1 && catagory[0] === "Aviation_1176") ||
                (catagory1?.length === 1 && catagory1?.[0]?.split(">")?.[0]?.trim() === "Aviation_1176") ||
                (crumbs?.length === 1 && crumbs?.[0]?.text === "Aviation")) ? (
                <div class="banner-wrapper overflow-hidden">
                  <div class="container-fluid">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="banner-wrapper-inside d-md-flex flex-wrap">
                          <div class="banner-content-left d-flex flex-column justify-content-center">
                            <div class="banner-content">
                              <h4>Global Individual Parts List From Airlines and MROS</h4>
                              <a
                                href="javascript:void(0)"
                                class="__btn __btn-white aviation-banner-btn"
                                onClick={() => navigate("/aviation-parts/")}
                              >
                                {dashboardCount?.count
                                  ? `Click here to access ${numberFormat(dashboardCount?.count)} Parts`
                                  : "Click Here"}
                              </a>
                            </div>
                          </div>
                          <div class="banner-content-right">
                            <div class="bcr-inside h-100">
                              <div class="banner-image-holder">
                                <div class="banner-image-wrap w-100 h-100">
                                  <img class="w-100 h-100 object-fit-cover" src={aviationImg} alt="" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
              <div className="fcm-header d-none d-lg-block">
                <div className="breadcrumb-container need-help">
                  <ol className="breadcrumb">
                    {loadingMain ? (
                      <Skeleton width={150} height={15} />
                    ) : (
                      <>
                        <li className="breadcrumb-item">
                          <a href="/listings/index.cfm/catid/1001">All Listings</a>
                        </li>
                        {typeof window !== "undefined" &&
                          Array.isArray(crumbs) &&
                          crumbs.map((crumb) => (
                            <li className="breadcrumb-item">
                              {crumb.link ? (
                                <a className="h-100" href={`${crumb.link}`}>
                                  {crumb.text}
                                </a>
                              ) : (
                                <span>{crumb.text}</span>
                              )}
                            </li>
                          ))}
                      </>
                    )}
                  </ol>

                  <div className="fcm-lhr ">
                    <div class="choose-list-type">
                      <OverlayTrigger
                        placement="top"
                        delay={{ show: 50, hide: 100 }}
                        overlay={
                          <Tooltip id="button-tooltip" {...props}>
                            Grid View
                          </Tooltip>
                        }
                      >
                        <a
                          href="javascript:void(0)"
                          class={`listview-icon ${!listingView ? "active" : ""} `}
                          onClick={() => setListingView(false)}
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10 3H3V10H10V3Z"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M21 3H14V10H21V3Z"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M21 14H14V21H21V14Z"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M10 14H3V21H10V14Z"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </a>
                      </OverlayTrigger>
                      <OverlayTrigger
                        placement="top"
                        delay={{ show: 50, hide: 100 }}
                        overlay={
                          <Tooltip id="button-tooltip" {...props}>
                            List View
                          </Tooltip>
                        }
                      >
                        <a
                          href="javascript:void(0)"
                          class={`listview-icon ${listingView ? "active" : ""} `}
                          onClick={() => setListingView(true)}
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M5 4H3V6H5V4Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                              d="M5 11H3V13H5V11Z"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M5 18H3V20H5V18Z"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <line x1="10.75" y1="5.25" x2="21.25" y2="5.25" stroke-width="1.5" stroke-linecap="round" />
                            <line
                              x1="10.75"
                              y1="12.25"
                              x2="21.25"
                              y2="12.25"
                              stroke-width="1.5"
                              stroke-linecap="round"
                            />
                            <line
                              x1="10.75"
                              y1="19.25"
                              x2="21.25"
                              y2="19.25"
                              stroke-width="1.5"
                              stroke-linecap="round"
                            />
                          </svg>
                        </a>
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>
                <div className="d-lg-flex align-items-lg-center flex-lg-wrap mb-2">
                  <div className="fcm-lhs ">
                    {loadingMain ? (
                      <Skeleton width={250} height={15} />
                    ) : (
                      <h1 className="cat-title mb-0">
                        {pageTittle} ({numberOfRecord})
                      </h1>
                    )}
                    {data.category &&
                      data.category.content_overview &&
                      (loadingMain ? (
                        ""
                      ) : (
                        // <Skeleton width={450} height={13} />
                        <div className="showing-result-text new-text-styles detail-auction-text-fix search-margin-fix">
                          {data.category.content_overview}
                        </div>
                      ))}

                    {loadingMain ? (
                      <div className="showing-result-text">{/* <Skeleton width={450} height={15} /> */}</div>
                    ) : (
                      <div className="showing-result-text  ">{queryData && `Showing results for "${queryData}"`}</div>
                    )}
                    <div className="showing-result-text detail-auction-text-fix "></div>
                  </div>
                </div>
              </div>
              <div className={"fcm-body"}>
                {!loadingMain ? (
                  <>
                    <div class="four-column-radio-group sale-type-radio fw-medium mb-4">
                      <div class="fcrg-item">
                        <div class="form-check radio">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="ABflexRadioDefault111"
                            id="ABflexRadio__11211"
                            onClick={() => setWantedListing(!wantedListing)}
                            checked={!wantedListing}
                          />
                          <label class="form-check-label" for="ABflexRadio__11211">
                            For Sale ({wantedListing ? count : numberOfRecord})
                          </label>
                        </div>
                      </div>
                      <div class="fcrg-item">
                        <div class="form-check radio">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="ABflexRadioDefault111"
                            id="ABflexRadio__21122"
                            onClick={() => setWantedListing(!wantedListing)}
                            checked={wantedListing}
                          />
                          <label class="form-check-label" for="ABflexRadio__21122">
                            Wanted ({wantedListing ? numberOfRecord : wantedCount})
                          </label>
                        </div>
                      </div>
                    </div>

                    {listings && listings.length > 0 ? (
                      <ul className={`${gridView ? "gridview d-flex flex-wrap" : "listview"} `}>
                        {/* {typeof window !== "undefined" && localStorage.getItem("token")
                          ? ""
                          : signupCard &&
                            (queryString.parse(props.location.search)["mfr"] ||
                              queryString.parse(props.location.search)["category"]) && (
                              <li className={`${gridView ? "grid-item" : "list-item"}  alert  fade show`}>
                                <div className="query-card-box d-flex flex-column flex-wrap">
                                  <div
                                    className="qcb-bg add-bg-prop"
                                  
                                  ></div>
                                  <div
                                    className="qcb-close-icon"
                                    data-bs-dismiss="alert"
                                    onClick={(e) => setSignUpCard(false)}
                                  >
                                    <img src={darkClose} alt="Close" />
                                  </div>
                                  <div className="qcb-text-box">
                                    <p>Receive updates on</p>
                                    <strong>
                                      {queryString.parse(props.location.search)["mfr"]
                                        ? queryString.parse(props.location.search)["mfr"]
                                        : queryString.parse(props.location.search)["subCategory"]
                                        ? queryString.parse(props.location.search)["subCategory"].split(">")[1]
                                        : queryString.parse(props.location.search)["category"]}
                                    </strong>
                                  </div>
                                  <div className="qcb-btn mt-auto">
                                    <a
                                      href="/members/register"
                                      target="_blank"
                                      className="btn btn-default btn-xs btn-block"
                                    >
                                      Sign up
                                    </a>
                                  </div>
                                </div>
                              </li>
                            )} */}
                        {listingView ? (
                          <div class="table-responsive mb-30 ">
                            <table class="product-list-table search-list-table table table-bordered table-wrap pipe-table-fix pipe-table-fix-new">
                              <thead class="table-light">
                                <tr>
                                  <th style={{ minWidth: "300px" }} className="cursor-pointer" colspan="2">
                                    <span className="standard-font-page-title">Item </span>{" "}
                                  </th>
                                  {!wantedListing ? (
                                    <th style={{ minWidth: "170px" }} className="cursor-pointer">
                                      <span className="standard-font-page-title">Seller </span>{" "}
                                    </th>
                                  ) : (
                                    ""
                                  )}
                                  <th style={{ minWidth: "215px" }} className="cursor-pointer">
                                    <span className="standard-font-page-title "> Current Asking Price</span>{" "}
                                  </th>
                                  <th style={{ minWidth: "215px" }} className="cursor-pointer  ">
                                    <span className="standard-font-page-title ">Wholesale Price </span>{" "}
                                  </th>
                                  <th className="cursor-pointer">
                                    <span className="standard-font-page-title ">Quantity</span>{" "}
                                  </th>

                                  <th className="cursor-pointer">
                                    <span className="standard-font-page-title ">
                                      {wantedListing ? "Target Purchase Region" : "Location"}
                                    </span>{" "}
                                  </th>

                                  {!wantedListing ? (
                                    <th style={{ minWidth: "135px" }} className="cursor-pointer">
                                      <span className="standard-font-page-title "># of Bids</span>{" "}
                                    </th>
                                  ) : (
                                    ""
                                  )}
                                  {!wantedListing ? (
                                    <th style={{ width: "105px", minWidth: "105px", maxWidth: "105px" }}></th>
                                  ) : (
                                    ""
                                  )}
                                </tr>
                              </thead>
                              <tbody>
                                {listings.map((e, i) => {
                                  return (
                                    <tr>
                                      <td>
                                        <div
                                          class="td-img cursor-pointer"
                                          onClick={(ev) => {
                                            ev.preventDefault();
                                            if (isMobile) {
                                              navigate(`/listings/listing_detail.cfm/aucid/${e.auction_id}`);
                                            } else {
                                              window.open(`/listings/listing_detail.cfm/aucid/${e.auction_id}`);
                                            }
                                          }}
                                        >
                                          <img style={{ maxHeight: "50px" }} src={e?.image} alt={e?.title} />
                                        </div>
                                      </td>
                                      <td>
                                        <a href={`/listings/listing_detail.cfm/aucid/${e.auction_id}`} target="_blank">
                                          {e?.title}
                                        </a>
                                        <div
                                          class="grid7-card-subtitle"
                                          style={{ marginTop: "5px", marginBottom: "5px", fontSize: "14px" }}
                                        >
                                          {e?.category}
                                        </div>{" "}
                                        {e?.conditionType ? (
                                          <div
                                            className="grid7-badge"
                                            style={{ width: "fit-content", marginRight: "5px" }}
                                          >
                                            {e.conditionType ? e.conditionType : ""}
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </td>
                                      {!wantedListing && (
                                        <td>
                                          {!isLoggedIn ? (
                                            <a
                                              href="javascript:void(0)"
                                              className="link-item"
                                              onClick={() => {
                                                typeof window !== "undefined" &&
                                                  localStorage.setItem("redirectUrl", window.location.href);
                                                navigate("/members/login");
                                              }}
                                              style={{
                                                textDecoration: "underline",
                                                color: "#47ad1d",
                                                fontWeight: "400",
                                                fontSize: " 15px",
                                              }}
                                            >
                                              (Login to view seller info)
                                            </a>
                                          ) : e?.proc_name ? (
                                            <span>{e?.proc_name}</span>
                                          ) : (
                                            <span>Confidential</span>
                                          )}
                                          {isLoggedIn && e?.proc_logo ? (
                                            <img
                                              className="seller-logo seller-logo-search d-block"
                                              src={e?.proc_logo}
                                              alt=""
                                            />
                                          ) : (
                                            ""
                                          )}
                                        </td>
                                      )}
                                      <td>
                                        {e?.asking_price > 0 ? (
                                          <div class="grid7-offer d-flex flex-column align-items-start">
                                            <div class="offer-total">$ {numberFormat(e?.asking_price)}</div>
                                            <div
                                              class="offer-badge cursor-pointer"
                                              onClick={(ed) => {
                                                ed.preventDefault();
                                                ed.stopPropagation();
                                                window.open(`/listings/listing_detail.cfm/aucid/${e.auction_id}`, {
                                                  state: { buyNowClicked: true },
                                                });
                                              }}
                                            >
                                              Buy Now or Counter Offer
                                            </div>
                                          </div>
                                        ) : (
                                          "N/A"
                                        )}
                                      </td>
                                      <td>
                                        {e?.wholesale_value > 0 ? (
                                          <div class="grid7-highlighted-content w-100">
                                            <div class="g-h-label">Wholesale Value</div>
                                            <div class="g-h-total">
                                              <span>$ {numberFormat(e.wholesale_value)}</span>
                                            </div>
                                          </div>
                                        ) : (
                                          "N/A"
                                        )}
                                      </td>
                                      <td>
                                        {e.quantity} {e.unit}
                                      </td>
                                      <td>{e.location ? e?.location : wantedListing ? "Global" : ""}</td>
                                      {!wantedListing ? (
                                        <td>
                                          {e.bid_count > 0 ? (
                                            <div
                                              class="grid7-badge"
                                              style={{ height: "fit-content", width: "fit-content" }}
                                            >
                                              {e.bid_count} {e.bid_count == "1" || e.bid_count == "0" ? "Bid" : "Bids"}
                                            </div>
                                          ) : (
                                            <div
                                              class="grid7-badge"
                                              style={{ height: "fit-content", width: "fit-content" }}
                                            >
                                              0 Bid
                                            </div>
                                          )}
                                        </td>
                                      ) : (
                                        ""
                                      )}
                                      {!wantedListing ? (
                                        <td>
                                          <a
                                            href="javascript:void(0)"
                                            style={{ textDecoration: "underline", color: "#47ad1d" }}
                                            onClick={(ej) => {
                                              ej.preventDefault();
                                              ej.stopPropagation();
                                              setSelectedListing(e);
                                              toggleBuyerModal();
                                            }}
                                          >
                                            Share with Buyers
                                          </a>
                                        </td>
                                      ) : (
                                        ""
                                      )}
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        ) : gridView ? (
                          listings.map((e) => (
                            <div class="grid7-card-item">
                              <div
                                class="grid7-card-box w-100 h-100 d-flex flex-column align-items-start cursor-pointer"
                                onClick={(ev) => {
                                  ev.preventDefault();
                                  if (isMobile) {
                                    navigate(`/listings/listing_detail.cfm/aucid/${e.auction_id}`);
                                  } else {
                                    window.open(`/listings/listing_detail.cfm/aucid/${e.auction_id}`);
                                  }
                                }}
                              >
                                <div class="grid7-card-img-box overflow-hidden">
                                  <img src={e.image} alt={e.title} />
                                  {!wantedListing ? (
                                    <div className="bid-intro-box  light-green d-flex align-items-center justify-content-center">
                                      <h4>Place a Bid</h4>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                                <div class="grid7-card-content flex-grow-1 d-flex flex-column align-items-start w-100">
                                  <div class="grid7-card-title">{e.title}</div>
                                  <div class="grid7-card-subtitle">{e.category}</div>
                                  {e.asking_price > 0 ? (
                                    <div class="grid7-offer d-flex flex-column align-items-start">
                                      <div class="offer-label">Current Asking Price</div>
                                      <div class="offer-total">$ {numberFormat(e.asking_price)}</div>
                                      <div
                                        class="offer-badge"
                                        onClick={(ed) => {
                                          ed.preventDefault();
                                          ed.stopPropagation();
                                          window.open(`/listings/listing_detail.cfm/aucid/${e.auction_id}`, {
                                            state: { buyNowClicked: true },
                                          });
                                        }}
                                      >
                                        Buy Now or Counter Offer
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                  {e.wholesale_value > 0 ? (
                                    <div class="grid7-highlighted-content w-100">
                                      <div class="g-h-label">Wholesale Value</div>
                                      <div class="g-h-total">
                                        <span>${numberFormat(e.wholesale_value)}</span>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}

                                  <div class="grid7-cans">
                                    {e.quantity} {e.unit}
                                  </div>
                                  <div class="grid7-location">
                                    {e.location ? e?.location : wantedListing ? "Global" : ""}
                                  </div>

                                  <div className="d-flex space-between align-items-center w-100">
                                    {!wantedListing ? (
                                      <>
                                        {e.bid_count > 0 ? (
                                          <>
                                            <div class="grid7-badge">
                                              {e.bid_count} {e.bid_count == "1" || e.bid_count == "0" ? "Bid" : "Bids"}
                                            </div>
                                          </>
                                        ) : (
                                          <>
                                            <div class="grid7-badge">0 Bid</div>{" "}
                                          </>
                                        )}
                                      </>
                                    ) : (
                                      ""
                                    )}

                                    {!wantedListing ? (
                                      <div
                                        style={{
                                          textDecoration: "underline",
                                          color: "#47ad1d",
                                          fontWeight: 400,
                                          fontSize: "0.875rem",
                                        }}
                                        onClick={(ej) => {
                                          ej.preventDefault();
                                          ej.stopPropagation();
                                          setSelectedListing(e);
                                          toggleBuyerModal();
                                        }}
                                      >
                                        Share with Buyers
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          listings.map((e) => (
                            <li className="list-item">
                              <a
                                href={"#!"}
                                onClick={(ev) => {
                                  ev.preventDefault();
                                  if (isMobile) {
                                    navigate(`/listings/listing_detail.cfm/aucid/${e.auction_id}`);
                                  } else {
                                    window.open(`/listings/listing_detail.cfm/aucid/${e.auction_id}`);
                                  }
                                }}
                                style={{ display: "unset" }}
                              >
                                <div className="list-box d-flex">
                                  <div className="list-img-box">
                                    <img src={e.image} alt={e.title} />
                                  </div>
                                  <div className="list-content-box d-flex flex-column">
                                    <h4 className="list-title">{e.title}</h4>
                                    <h6 className="list-sub-title">{e.category}</h6>
                                    {e.asking_price > 0 ? (
                                      <div class="grid7-offer d-flex flex-column align-items-start">
                                        <div class="offer-label">Current Asking Price</div>
                                        <div class="offer-total">$ {numberFormat(e.asking_price)}</div>
                                        <div
                                          class="offer-badge"
                                          onClick={(ed) => {
                                            ed.preventDefault();
                                            ed.stopPropagation();
                                            window.open(`/listings/listing_detail.cfm/aucid/${e.auction_id}`, {
                                              state: { buyNowClicked: true },
                                            });
                                          }}
                                        >
                                          Buy Now or Counter Offer
                                        </div>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                    {e.wholesale_value > 0 ? (
                                      <div class="grid7-highlighted-content w-100">
                                        <div class="g-h-label">Wholesale Value</div>
                                        <div class="g-h-total">
                                          <span>${numberFormat(e.wholesale_value)}</span>
                                        </div>
                                      </div>
                                    ) : (
                                      ""
                                    )}

                                    <p className="list-pick-intro">
                                      {e.quantity} {e.unit}
                                    </p>
                                    <small className="list-location-desc" style={{ marginBottom: "15px" }}>
                                      {e.location ? e?.location : wantedListing ? "Global" : ""}
                                    </small>

                                    {!wantedListing ? (
                                      <>
                                        {e.bid_count > 0 ? (
                                          <div
                                            class="grid7-badge"
                                            style={{ height: "fit-content", width: "fit-content" }}
                                          >
                                            {e.bid_count} {e.bid_count == "1" || e.bid_count == "0" ? "Bid" : "Bids"}
                                          </div>
                                        ) : (
                                          <div
                                            class="grid7-badge"
                                            style={{ height: "fit-content", width: "fit-content" }}
                                          >
                                            0 Bid
                                          </div>
                                        )}
                                      </>
                                    ) : (
                                      ""
                                    )}
                                    {!wantedListing ? (
                                      <div className="list-bott-box mt-auto d-md-flex align-items-md-center">
                                        <div className="list-btn-group ms-md-auto">
                                          <a
                                            href={`/listings/listing_detail.cfm/aucid/${e.auction_id}`}
                                            className="btn btn-default btn-xs"
                                            target="_blank"
                                          >
                                            Place a bid
                                          </a>
                                        </div>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                              </a>
                            </li>
                          ))
                        )}
                      </ul>
                    ) : (
                      !loadingMain && (
                        <div className="empty-block-container empty-block-container-search text-center">
                          <div className="empty-block-icon">
                            <img src={emptyIcon} alt="empty List" />
                          </div>
                          <h4>No Listings Found!</h4>
                        </div>
                      )
                    )}
                  </>
                ) : (
                  <div class="table-responsive mb-30 ">
                    <table class="product-list-table search-list-table table table-bordered table-wrap pipe-table-fix pipe-table-fix-new">
                      <thead class="table-light">
                        <tr>
                          <th style={{ minWidth: "300px" }} className="cursor-pointer" colspan="2">
                            <span className="standard-font-page-title">Item </span>{" "}
                          </th>
                          {!wantedListing ? (
                            <th style={{ minWidth: "170px" }} className="cursor-pointer">
                              <span className="standard-font-page-title">Seller </span>{" "}
                            </th>
                          ) : (
                            ""
                          )}
                          <th style={{ minWidth: "215px" }} className="cursor-pointer">
                            <span className="standard-font-page-title "> Current Asking Price</span>{" "}
                          </th>
                          <th style={{ minWidth: "215px" }} className="cursor-pointer  ">
                            <span className="standard-font-page-title ">Wholesale Price </span>{" "}
                          </th>
                          <th className="cursor-pointer">
                            <span className="standard-font-page-title ">Quantity</span>{" "}
                          </th>

                          <th className="cursor-pointer">
                            <span className="standard-font-page-title ">
                              {wantedListing ? "Target Purchase Region" : "Location"}
                            </span>{" "}
                          </th>

                          {!wantedListing ? (
                            <th style={{ minWidth: "135px" }} className="cursor-pointer">
                              <span className="standard-font-page-title "># of Bids</span>{" "}
                            </th>
                          ) : (
                            ""
                          )}
                          {!wantedListing ? (
                            <th style={{ width: "105px", minWidth: "105px", maxWidth: "105px" }}></th>
                          ) : (
                            ""
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {[1, 2, 3, 4, 5, 6, 7, 8, 6, 3, 4].map((e, i) => {
                          return (
                            <tr>
                              <td>
                                <div class="td-img cursor-pointer">
                                  <Skeleton height={"50px"} />
                                </div>
                              </td>
                              <td>
                                <Skeleton />
                              </td>
                              {!wantedListing && (
                                <td>
                                  <Skeleton />
                                </td>
                              )}
                              <td>
                                <Skeleton />
                              </td>
                              <td>
                                <Skeleton />
                              </td>
                              <td>
                                <Skeleton />
                              </td>
                              <td>
                                {" "}
                                <Skeleton />
                              </td>
                              {!wantedListing ? (
                                <td>
                                  <Skeleton />
                                </td>
                              ) : (
                                ""
                              )}
                              {!wantedListing ? (
                                <td>
                                  <Skeleton />
                                </td>
                              ) : (
                                ""
                              )}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
                {isMobile ? (
                  <div className="pagination-container d-flex align-items-center justify-content-between">
                    {mobilePages.length > 1 ? (
                      <div
                        className="pagination-btn prev-btn"
                        onClick={(e) => handleChange(e, page)}
                        style={{ pointerEvents: page === 0 ? "none" : "unset" }}
                      >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M11 17L6 12L11 7"
                            stroke="black"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M18 17L13 12L18 7"
                            stroke="black"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <span>Previous</span>
                      </div>
                    ) : (
                      ""
                    )}
                    <ul className="pagination">
                      {page + 1 > 4 ? (
                        <li
                          onClick={(e) => {
                            handleChange(e, 1);
                          }}
                          className={"page-item"}
                        >
                          <a
                            className="page-link"
                            href={`javascript:void(0)`}
                            onClick={(e) => {
                              e.preventDefault();
                            }}
                          >
                            1
                          </a>
                        </li>
                      ) : (
                        ""
                      )}

                      {page > 3 ? <li className={"page-item"}>...</li> : ""}
                      {mobilePages.map(
                        (i) =>
                          i + 1 <= maxPage && (
                            <li
                              onClick={(e) => {
                                handleChange(e, i + 1);
                              }}
                              className={page === i ? "page-item active" : "page-item"}
                            >
                              <a
                                className="page-link"
                                href={`javascript:void(0)`}
                                onClick={(e) => {
                                  e.preventDefault();
                                }}
                              >
                                {i + 1}
                              </a>
                            </li>
                          ),
                      )}
                      {page < maxPage - 2 && maxPage > 2 ? <li className={"page-item"}>...</li> : ""}

                      {page < maxPage - 3 && maxPage > 2 ? (
                        <li
                          onClick={(e) => {
                            handleChange(e, maxPage);
                          }}
                          className={"page-item"}
                        >
                          <a
                            className="page-link"
                            href={`javascript:void(0)`}
                            onClick={(e) => {
                              e.preventDefault();
                            }}
                          >
                            {maxPage - 1}
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                      {page < maxPage - 2 && maxPage > 2 ? (
                        <li
                          onClick={(e) => {
                            handleChange(e, maxPage);
                          }}
                          className={"page-item"}
                        >
                          <a
                            className="page-link"
                            href={`javascript:void(0)`}
                            onClick={(e) => {
                              e.preventDefault();
                            }}
                          >
                            {maxPage}
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                    </ul>
                    {mobilePages.length > 1 ? (
                      <div
                        className={`pagination-btn next-btn ${maxPage <= page + 1 ? "button-link-disabled" : ""}`}
                        onClick={(e) => handleChange(e, page + 2)}
                      >
                        <span>Next </span>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M13 17L18 12L13 7"
                            stroke="black"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M6 17L11 12L6 7"
                            stroke="black"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                ) : pages.length > 1 && !loadingMain ? (
                  <div className="pagination-container d-flex align-items-center justify-content-between">
                    <div
                      className="pagination-btn prev-btn"
                      onClick={(e) => handleChange(e, page)}
                      style={{ pointerEvents: page === 0 ? "none" : "unset" }}
                    >
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M11 17L6 12L11 7"
                          stroke="black"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M18 17L13 12L18 7"
                          stroke="black"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <span>Previous</span>
                    </div>
                    <ul className="pagination">
                      {page + 1 > 6 ? (
                        <li
                          onClick={(e) => {
                            handleChange(e, 1);
                          }}
                          className={"page-item"}
                        >
                          <a
                            className="page-link"
                            href={`javascript:void(0)`}
                            onClick={(e) => {
                              e.preventDefault();
                            }}
                          >
                            1
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                      {page + 1 > 7 ? (
                        <li
                          onClick={(e) => {
                            handleChange(e, 2);
                          }}
                          className={"page-item"}
                        >
                          <a
                            className="page-link"
                            href={`javascript:void(0)`}
                            onClick={(e) => {
                              e.preventDefault();
                            }}
                          >
                            2
                          </a>
                        </li>
                      ) : (
                        ""
                      )}{" "}
                      {page + 1 > 8 ? (
                        <li
                          onClick={(e) => {
                            handleChange(e, 3);
                          }}
                          className={"page-item"}
                        >
                          <a
                            className="page-link"
                            href={`javascript:void(0)`}
                            onClick={(e) => {
                              e.preventDefault();
                            }}
                          >
                            3
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                      {page > 5 ? <li className={"page-item"}>...</li> : ""}
                      {pages.map(
                        (i) =>
                          i + 1 <= maxPage && (
                            <li
                              onClick={(e) => {
                                handleChange(e, i + 1);
                              }}
                              className={page === i ? "page-item active" : "page-item"}
                            >
                              <a
                                className="page-link"
                                href={`javascript:void(0)`}
                                onClick={(e) => {
                                  e.preventDefault();
                                }}
                              >
                                {i + 1}
                              </a>
                            </li>
                          ),
                      )}
                      {page < maxPage - 5 && maxPage > 10 ? <li className={"page-item"}>...</li> : ""}
                      {page < maxPage - 7 && maxPage > 10 ? (
                        <li
                          onClick={(e) => {
                            handleChange(e, maxPage - 2);
                          }}
                          className={"page-item"}
                        >
                          <a
                            className="page-link"
                            href={`javascript:void(0)`}
                            onClick={(e) => {
                              e.preventDefault();
                            }}
                          >
                            {maxPage - 2}
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                      {page < maxPage - 6 && maxPage > 10 ? (
                        <li
                          onClick={(e) => {
                            handleChange(e, maxPage - 1);
                          }}
                          className={"page-item"}
                        >
                          <a
                            className="page-link"
                            href={`javascript:void(0)`}
                            onClick={(e) => {
                              e.preventDefault();
                            }}
                          >
                            {maxPage - 1}
                          </a>
                        </li>
                      ) : (
                        ""
                      )}{" "}
                      {page < maxPage - 5 && maxPage > 10 ? (
                        <li
                          onClick={(e) => {
                            handleChange(e, maxPage);
                          }}
                          className={"page-item"}
                        >
                          <a
                            className="page-link"
                            href={`javascript:void(0)`}
                            onClick={(e) => {
                              e.preventDefault();
                            }}
                          >
                            {maxPage}
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                    </ul>

                    <div
                      className={`pagination-btn next-btn ${maxPage <= page + 1 ? "button-link-disabled" : ""}`}
                      onClick={(e) => handleChange(e, page + 2)}
                    >
                      <span>Next </span>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M13 17L18 12L13 7"
                          stroke="black"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M6 17L11 12L6 7"
                          stroke="black"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
              {data.category && data.category.content_full && (
                <div
                  className="p-4"
                  dangerouslySetInnerHTML={{
                    __html: data.category?.content_full.replace(/<\/?[^>]+(>|$)/g, "").replace("#FFFFFF", "#0b0000"),
                  }}
                ></div>
              )}
              {archiveFor && (
                <div className="p-4">
                  <a href={`/archives/${archiveFor}`} style={{ color: "#4bac31", textDecoration: "underline" }}>
                    Click here
                  </a>{" "}
                  to view the{" "}
                  <b>
                    {pageTittle}
                    For Sale in Online Surplus Auctions
                  </b>{" "}
                  archives.
                </div>
              )}
            </div>
          </div>

          {!loadingMain && (
            <div className="mob-filter-btn-group d-lg-none d-flex align-items-center">
              <a
                href="javascript:void(0)"
                className="filter-btn d-flex align-items-center justify-content-center sidebar_toggler"
                data-toggle="filter-box"
                onClick={(e) => {
                  e.preventDefault();
                  setShowFilterSideBarMobile(!showFilterSidebarMobile);
                }}
              >
                {filterCount > 0 ? <p>{`Filters (${filterCount})`}</p> : <p>Filters</p>}
              </a>
            </div>
          )}
          <Footer />
        </div>
      </>
      <FilterSideBarMobile
        showModal={showFilterSidebarMobile}
        toggleModal={() => setShowFilterSideBarMobile(!showFilterSidebarMobile)}
        facets={facets}
        setData={setData}
        catagory={catagory}
        catagory1={catagory1}
        catagory2={catagory2}
        aviationModel={aviationModel}
        conditionType={conditionType}
        make={make}
        model={model}
        region={region}
        region1={region1}
        toggleFilter={() => setShowFilterModal(!showFilterModal)}
        filterModalData={(data) => setFilterModalData(data)}
        filterModalDataCounts={(count) => setFilterModalDataCounts(count)}
        modalType={(t) => setModalType(t)}
        clearFilter={(val) => clearFilter(val)}
        removeFilter={removeFilter}
        setGridView={setGridView}
        loadingMain={loadingMain}
      />
      <FilterModal
        showModal={showFilterModal}
        toggleModal={() => setShowFilterModal(!showFilterModal)}
        filterModalData={filterModalData}
        filterModalDataCounts={filterModalDataCounts}
        catagory={
          modalType === "catagory"
            ? catagory
            : modalType === "catagory1"
            ? catagory1
            : modalType === "make"
            ? make
            : // : modalType === "model"
              // ? model
              region
        }
        setData={setData}
        clearFilter={(val) => clearFilter(val)}
        modalType={modalType}
      />
      <ShareWithMyBuyers show={showBuyerModal} onHide={toggleBuyerModal} listing={selectedListing} />
    </>
  );
};
export default App;
export const Head = ({ pageContext: data, location }) => (
  <>
    <SEO
      canonical={`https://www.salvex.com${location.pathname}`}
      pathname={location.pathname}
      page={typeof window !== "undefined" && window?.history?.state?.page}
      totalPages={typeof window !== "undefined" && window?.history?.state?.totalPages}
      title={
        location?.pathname?.includes("search")
          ? "Listings Available For Sale"
          : data.category && data.category.meta_title
          ? data.category.meta_title
          : `Used ${
              data.category && data.category.description ? data.category.description : ""
            } For Sale in Online Surplus Auctions ${
              data.geoRegion
                ? data.geoRegion.description
                  ? `in ${data.geoRegion.description}`
                  : `in ${data.geoRegion.geoRegion}`
                : ""
            }${data.manufacturer ? " made by " + data.manufacturer.description : ""}`
      }
      description={
        location?.pathname?.includes("search")
          ? "Listings Available For Sale"
          : data.category && data.category.meta_description
          ? data.category.meta_description
          : `Used ${
              data.category && data.category.description ? data.category.description : ""
            } For Sale in Online Surplus Auctions ${
              data.geoRegion
                ? data.geoRegion.description
                  ? `in ${data.geoRegion.description}`
                  : `in ${data.geoRegion.geoRegion}`
                : ""
            }${data.manufacturer ? " made by " + data.manufacturer.description : ""}`
      }
    />
  </>
);
